export const LandingReviews = () => {
    const reviews = [
        {
            name: "Sergio Pivato",
            initials: "SP",
            badge: "Local Guide",
            text: "Super recomendo, Dr Luke Pacces me defendeu em um processo contra uma operadora, muito competente e inteligente além de ser uma pessoa que não hesita em prestar todos os esclarecimentos sobre o andamento dos processos e fazer o devido acompanhamento do mesmo. Fiquei muito satisfeito com o resultado obtido na ação e caso tenha algum outro problema de ordem legal, certamente o procurarei.",
            highlights: null
        },
        {
            name: "Felipe Lima",
            initials: "FL",
            badge: null,
            text: "Ótimo profissional, atencioso, tirou todas as dúvidas no decorrer do processo de usucapião que entramos e em pouco tempo estava com a documentação do meu imóvel!",
            highlights: ["Qualidade", "Profissionalismo", "Valor"]
        },
        {
            name: "Aline de Bitencourt",
            initials: "AB",
            badge: "Local Guide",
            text: "Atendimento excelente, muito atencioso e todos prestativos! Super indico sempre, tenho muita confiança!",
            highlights: null
        },
        {
            name: "Janete Maria Silveira",
            initials: "JS",
            badge: null,
            text: "Sempre que preciso estão dispostos a me ajudar e resolver os problemas! Muito atenciosos, tenho confiança e sempre indico Pacces Advogado, Dr. Luke. Obrigada!",
            highlights: null
        },
        {
            name: "Priscila Capeto Barreiros",
            initials: "PB",
            badge: "Local Guide",
            text: "Um excelente escritório de advocacia! São prestativos e esclarecedores do início ao fim do processo! Recomendo!",
            highlights: ["Receptividade", "Qualidade", "Profissionalismo", "Valor"]
        }
    ];

    const Stars = () => (
        <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-4 h-4 fill-[#FBBC04]" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
            ))}
        </div>
    );

    return (
        <section className="py-32 bg-white font-sans">
            <div className="max-w-7xl mx-auto px-6">

                {/* Header */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
                    <div className="space-y-4">
                        <span className="text-pacces-gold font-bold text-[12px] uppercase tracking-[0.4em] block">Reputação</span>
                        <h2 className="text-4xl md:text-5xl font-serif text-pacces-ebony leading-[0.95] tracking-tighter">
                            O que nossos Clientes<br />
                            dizem sobre nós
                        </h2>
                    </div>

                    {/* Rating summary */}
                    <a
                        href="https://share.google/fzfeCUBcl6BbJHtWe"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-5 bg-white border border-stone-200 px-6 py-4 hover:border-pacces-gold/40 transition-colors duration-300 group"
                    >
                        <div className="text-center">
                            <div className="text-3xl font-serif text-pacces-ebony font-light leading-none">5,0</div>
                            <div className="mt-1">
                                <Stars />
                            </div>
                        </div>
                        <div className="border-l border-stone-200 pl-5">
                            <div className="flex items-center gap-2 mb-0.5">
                                <svg className="w-4 h-4" viewBox="0 0 24 24">
                                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                                </svg>
                                <span className="text-[12px] font-bold text-pacces-ebony uppercase tracking-[0.15em]">Google Reviews</span>
                            </div>
                            <p className="text-[12px] text-stone-400 uppercase tracking-widest group-hover:text-pacces-gold transition-colors duration-300">Ver todas as avaliações →</p>
                        </div>
                    </a>
                </div>

                {/* Cards grid */}
                <div className="grid md:grid-cols-3 gap-px bg-stone-200">
                    {reviews.map((review, index) => (
                        <div
                            key={index}
                            className="bg-white p-8 flex flex-col gap-5 hover:bg-stone-50 transition-colors duration-300"
                        >
                            {/* Top: avatar + name + stars */}
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-pacces-ebony flex items-center justify-center flex-shrink-0">
                                    <span className="text-[12px] font-bold text-pacces-gold tracking-wide">{review.initials}</span>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="text-[13px] font-bold text-pacces-ebony truncate">{review.name}</div>
                                    {review.badge && (
                                        <div className="text-[12px] text-stone-400 uppercase tracking-widest">{review.badge}</div>
                                    )}
                                </div>
                            </div>

                            <Stars />

                            {/* Text */}
                            <p className="text-base text-stone-500 font-light leading-relaxed flex-1">
                                "{review.text}"
                            </p>

                            {/* Highlights */}
                            {review.highlights && (
                                <div className="flex flex-wrap gap-1.5 pt-2 border-t border-stone-100">
                                    {review.highlights.map((h, i) => (
                                        <span key={i} className="text-[12px] uppercase tracking-[0.2em] font-bold text-pacces-gold border border-pacces-gold/30 px-2 py-0.5">
                                            {h}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}

                    {/* Filler cell para fechar o grid 3x2 */}
                    <div className="bg-white p-8 flex flex-col items-center justify-center gap-4 hover:bg-stone-50 transition-colors duration-300">
                        <div className="text-5xl font-serif text-pacces-gold font-light">5,0</div>
                        <div className="flex gap-1">
                            {[...Array(5)].map((_, i) => (
                                <svg key={i} className="w-5 h-5 fill-[#FBBC04]" viewBox="0 0 24 24">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                </svg>
                            ))}
                        </div>
                        <p className="text-[12px] uppercase tracking-[0.3em] text-stone-400 text-center">Nota máxima<br />no Google</p>
                        <a
                            href="https://share.google/fzfeCUBcl6BbJHtWe"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-2 text-[12px] font-bold uppercase tracking-[0.25em] text-pacces-ebony border border-pacces-ebony px-5 py-2.5 hover:bg-pacces-ebony hover:text-pacces-ivory transition-all duration-300"
                        >
                            Ver no Google
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
